<template lang="">
  <div>
    <!-- {{ locationEntries }} -->

    <b-row class="match-height">
      <b-col
        xl="4"
        md="4"
        sm="6"
      >
        <statistic-card-vertical
          color="primary"
          icon="MapIcon"
          :statistic="locationEntries.length"
          statistic-title="Standorte"
        />
      </b-col>
      <b-col
        xl="4"
        md="4"
        sm="6"
      >
        <statistic-card-vertical
          color="success"
          icon="BoxIcon"
          :statistic="totalStorageUnits"
          statistic-title="Lagereinheiten gesamt"
        />
      </b-col>
      <b-col
        xl="4"
        md="4"
        sm="6"
      >
        <statistic-card-vertical
          color="primary"
          icon="TrendingUpIcon"
          :statistic="averageStoragePerLocation"
          statistic-title="⌀ Lager/Standort"
        />
      </b-col>
    </b-row>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="mr-1">Zeige</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-1"
              style="min-width: 80px; max-width: 100px;"
            />
            <label class="ml-1">Einträge</label>
          </b-col>
          <b-col
            cols="12"
            md="6"
          ><div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="filter"
              class="d-inline-block mr-1"
              placeholder="Suche..."
              type="search"
            />
            <!--  -->
            <!-- Sidebar -->
            <!--  -->
            <b-button
              variant="primary"
              type="button"
              @click="createNewObject()"
            >
              <span class="text-nowrap">Standort hinzufügen</span>
            </b-button>

            <b-sidebar
              id="sidebar-right"
              bg-variant="white"
              right
              backdrop
              shadow
              no-header
            >
              <sidebar-content />
            </b-sidebar>
            <b-sidebar
              id="sidebar-right-edit"
              bg-variant="white"
              right
              backdrop
              shadow
              no-header
            >
              <sidebar-content
                :id="editLocationData.id"
                :is-edit-mode="isEditMode"
                :edit-location-entry="editLocationData"
                :location="editLocationData"
                @update-event="getTotalRows"
              />
            </b-sidebar>
          </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-card no-body>
          <b-table
            ref="refListTable"
            striped
            hover
            :current-page="currentPage"
            :per-page="perPage"
            :items="locationEntries"
            :fields="fields"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive
            show-empty
            empty-text="Keine Einträge gefunden"
            @row-clicked="onRowClicked"
          >
            <template #cell(street)="data">
              {{ data.item.street }} {{ data.item.streetNumber }}
            </template>
            <template #cell(storages.length)="data">
              <b-badge
                pill
                variant="success"
              >
                {{ data.item.storages.length }}
              </b-badge>
            </template>
            <template #cell(isVisibleOrder)="data">
              <b-badge
                pill
                :variant="data.item.isVisibleOrder ? 'success' : 'secondary'"
              >
                {{ data.item.isVisibleOrder ? 'Ja' : 'Nein' }}
              </b-badge>
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  :to="{
                    name: 'locations-view',
                    params: { id: data.item.id },
                  }"
                >
                  <feather-icon icon="FileTextIcon" />
                  <span class="align-middle ml-50">Öffnen</span>
                </b-dropdown-item>

                <b-dropdown-item @click="editObject(data)">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Bearbeiten</span>
                </b-dropdown-item>

                <b-dropdown-item @click="deleteWarning(data)">
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Löschen</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span
                  class="text-muted"
                >Zeige {{ dataMeta.from }} bis {{ dataMeta.to }} von
                  {{ dataMeta.of }} Einträge</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </b-card>
  </div>
</template>

<script>
// @ts-nocheck
import {
  BCard,
  BTable,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BPagination,
  BBadge,
  BLink,
  BSidebar,
  VBToggle,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SidebarContent from './LocationListAddNew.vue'
import tableHelper from '../../Table+Helper'

export default {
  setup() {
    const {
      perPageOptions,
      perPage,
      filter,
      totalRows,
      currentPage,
      refListTable,
      dataMeta,
      refetchData,
    } = tableHelper()

    return {
      perPageOptions,
      filter,
      perPage,
      totalRows,
      currentPage,
      refListTable,
      dataMeta,
      refetchData,
    }
  },
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BPagination,
    BBadge,
    BLink,
    vSelect,
    StatisticCardVertical,
    BSidebar,
    VBToggle,
    SidebarContent,
    BDropdown,
    BDropdownItem,
    ToastificationContent,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      editLocationData: [],
      isEditMode: false,
      refListTable: null,
      sortBy: 'id',
      sortDesc: true,
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'city',
          label: 'Stadt',
          sortable: true,
        },
        {
          key: 'street',
          label: 'Straße',
          sortable: true,
        },
        {
          key: 'zipCode',
          label: 'PLZ',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Land',
          sortable: true,
        },
        {
          key: 'storages.length',
          label: 'Lager',
          sortable: true,
        },
        {
          key: 'isVisibleOrder',
          label: 'Shop sichtbar',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Aktionen',
        },
      ],
    }
  },
  computed: {
    locationEntries() {
      return this.$store.getters.locationsEntries
    },
    getTotalRows() {
      return this.locationEntries.length
    },
    totalStorageUnits() {
      return this.locationEntries.reduce((total, location) => total + (location.storages ? location.storages.length : 0), 0)
    },
    averageStoragePerLocation() {
      if (this.locationEntries.length === 0) return 0
      return Math.round(this.totalStorageUnits / this.locationEntries.length)
    },
  },
  watch: {
    // Watch search input and reset pagination when it changes
    filter: {
      handler() {
        this.currentPage = 1
      },
    },
  },
  mounted() {
    this.totalRows = this.getTotalRows
  },
  methods: {
    onRowClicked(item) {
      this.$router.push(`/locations-view/${item.id}`)
    },
    deleteWarning(data) {
      // Check if location has storages
      if (data.item.storages && data.item.storages.length > 0) {
        this.$swal({
          title: 'Löschen nicht möglich',
          text: `Der Standort "${data.item.name}" kann nicht gelöscht werden, da noch ${data.item.storages.length} Lager zugeordnet sind. Bitte löschen Sie zuerst alle Lager dieses Standorts.`,
          icon: 'error',
          confirmButtonText: 'Verstanden',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        return
      }

      this.$swal({
        title: 'Bist du sicher?',
        // text: 'Das Lager wird unwiederruflich gelöscht.',
        text: `Den Standort "${data.item.name}" wirklich löschen?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, löschen!',
        cancelButtonText: 'Abbrechen',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch('deleteLocation', data.item.id)
            .then(() => {
              this.$store.dispatch('getLocationsEntries')
              this.toastNotification(
                'Standort erfolgreich gelöscht.',
                'CheckIcon',
                'success'
              )
            })
            .catch(() => {
              this.toastNotification(
                'Standort konnte nicht gelöscht werden.',
                'AlertTriangleIcon',
                'danger'
              )
            })
        }
      })
    },
    createNewObject() {
      this.isEditMode = false
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    editObject(data) {
      this.editLocationData = data.item
      this.isEditMode = true
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right-edit')
    },
    toastNotification(title, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
